import PropTypes from 'prop-types';

import { NavbarDropdown } from '@febos-io/design';

import NavbarOption from './NavbarOption';
import HasPermission from './HasPermission';

export function NavbarDropdownOptions(
  {
    icon,
    text,
    options = [],
    defaultId,
    i18nNamespace
  }
) {
  return (
    <NavbarDropdown
      defaultId={defaultId}
      text={text}
      icon={icon}
      i18nNamespace={i18nNamespace}
    >
      {options.map((option) => (
        <HasPermission
          key={option.text}
          roles={option.roles}
        >
          <NavbarOption
            text={option.text}
            icon={option.icon}
            to={option.to}
            i18nNamespace={i18nNamespace}
          />
        </HasPermission>
      ))}
    </NavbarDropdown>
  );
}

NavbarDropdownOptions.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    icon: PropTypes.string,
    to: PropTypes.string
  })),
  defaultId: PropTypes.string,
  i18nNamespace: PropTypes.string
};

export default NavbarDropdownOptions;
